<ap-panel
    class="ap-flex ap-flex-grow-1 ap-justify-content-center ap-align-content-center ap-text-align-center ap-margin-bottom-0"
    type="primary"
    aria-describedby="inactivity_message"
    aria-live="assertive"
>
    <div ap-panel-body class="ap-margin-0">
        <h2 id="inactivity_message" class="ap-margin-top-1 ap-padding-bottom-1">
            {{ 'conversational.chat.inactivityprompt.title' | apContent }}
        </h2>
        <ap-button (onClick)="setSelectContinue()" data-testid="idle-continue" aria-describedby="inactivity_message">
            {{ 'conversational.chat.inactivityprompt.button.continue' | apContent }}
        </ap-button>
        <ap-button (onClick)="setSelectEnd()" data-testid="idle-stop" aria-describedby="inactivity_message">
            {{ 'conversational.chat.inactivityprompt.button.stop' | apContent }}
        </ap-button>
    </div>
</ap-panel>
